'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Columns;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Column = require('./Column');

var _Column2 = _interopRequireDefault(_Column);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  {
    "type": "columns",
    "columns": [
      {
        "title": "Critical Skills",
        "content": [
          "Problem solving",
          "Interpersonal skills",
          "Communication proficiency",
        ]
      },
      {
        "title": "Key Responsibilities",
        "content": [
          "Posts cash receipts on a daily basis.",
          "Maintains a spreadsheet for joint checks",
          "Reconciles joint checks to the general ledger",
        ]
      }
    ]
  }

  For displaying columns in a body.
*/

function Columns(_ref) {
  var moduleClass = _ref.moduleClass,
      columns = _ref.columns;

  return _react2.default.createElement(
    'div',
    {
      className: 'columns type-columns ' + moduleClass
    },
    columns.map(function (_ref2, key) {
      var title = _ref2.title,
          content = _ref2.content;
      return _react2.default.createElement(_Column2.default, {
        key: key,
        title: title,
        content: content
      });
    })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Columns/Columns.jsx
// module id = 1148
// module chunks = 0